module.exports = __webpack_public_path__ + "static/media/m15.06c47790.jpg";